import styled from '@emotion/styled';

import {
  getCardBaseStyles,
  getCardCenterStyles,
  getCardClickableStyles,
  getCardStickyStyles,
} from './card-styles';
import type { StyledCardProps } from './types';

export const StyledCard = styled.div<StyledCardProps>`
  position: relative;
  display: block;
  transition:
    box-shadow 0.2s ease,
    transform 0.1s ease,
    background-color 0.2s ease,
    border-color 0.2s ease;

  ${({ $styleProps }) => getCardBaseStyles($styleProps)}

  ${({ $clickable = false, $styleProps }) => getCardClickableStyles($clickable, $styleProps)}

  ${({ $overflowHidden }) => $overflowHidden && `overflow: hidden;`}

  ${({ $center = false }) => getCardCenterStyles($center)}

  ${({ $sticky = false, $styleProps }) => getCardStickyStyles($sticky, $styleProps)}
`;